import CollectionPosts from "./collections-posts";

export default CollectionPosts;